import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'Our Story' },
    { path: '/memories', label: 'Memories' },
    { path: '/notes', label: 'Love Notes' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
            data-testid="nav-logo"
          >
            <Heart className="w-6 h-6 text-[#D4AF37] group-hover:scale-110 transition-transform" fill="#D4AF37" />
            <span className="font-['Playfair_Display'] text-lg font-semibold text-[#F5F5F0]">
              Year One
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${isActive(link.path) ? 'text-[#D4AF37]' : ''}`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/secret"
              className="text-[#D4AF37] text-xs tracking-widest uppercase hover:text-[#F5F5F0] transition-colors"
              data-testid="nav-link-secret"
            >
              Secret
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#F5F5F0] p-2"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-[#D4AF37]/20 animate-fade-in" data-testid="mobile-menu">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 px-4 text-sm uppercase tracking-widest ${
                  isActive(link.path) ? 'text-[#D4AF37]' : 'text-[#F5F5F0]'
                } hover:text-[#D4AF37] transition-colors`}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/secret"
              className="block py-3 px-4 text-sm uppercase tracking-widest text-[#D4AF37] hover:text-[#F5F5F0] transition-colors"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-nav-link-secret"
            >
              Secret
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
